'use client';

import type { FC, SyntheticEvent } from 'react';

import { CarouselItem } from '@wwe-portal/ui/components/carousel';

import type {
  FlagShipCardProps,
  FlagShipOffer,
  FlagshipSliderProps,
} from '../../type';
import { FlagshipCard } from '../flagship';

import { FlagshipSliderLayout } from './layout';

const Card: FC<{ data: FlagShipCardProps }> = ({ data }) => {
  return (
    <div className="px-0">
      <FlagshipCard {...data} />
    </div>
  );
};

const WrappedCarouselItem: FC<{
  item: FlagShipOffer;
  onClick?: (offerId: string, e: SyntheticEvent) => void;
  onClickPrice?: (
    offerId: string,
    e: SyntheticEvent,
    context: {
      slideIndex: number;
      totalSlides: number;
    }
  ) => void;
  analyticsContext: {
    slideIndex: number;
    totalSlides: number;
  };
}> = ({ item, analyticsContext, onClick, onClickPrice }) => {
  return (
    <CarouselItem
      className="h-[320px] basis-[calc(100%-32px)] px-3 md:h-[420px] md:basis-full md:px-0"
      data-carousel-item
    >
      <Card
        data={{
          offer: item,
          onClick: (e) => onClick?.(item.id, e),
          onClickPrice: (e) => onClickPrice?.(item.id, e, analyticsContext),
        }}
      />
    </CarouselItem>
  );
};

export const FlagshipSlider: FC<FlagshipSliderProps> = ({
  items,
  children,
  onClick,
  onClickPrice,
}) => {
  if (items.length === 0) return null;
  if (items.length === 1) {
    const item = items[0];
    if (!item) return null;
    return (
      <div className="h-[300px] px-7 pb-6 md:h-[420px] md:px-3">
        <Card
          data={{
            offer: item,
            onClick: (e) => onClick?.(item.id, e),
            onClickPrice: (e) =>
              onClickPrice?.(item.id, e, {
                slideIndex: 0,
                totalSlides: 1,
              }),
          }}
        />
      </div>
    );
  }
  return (
    <div className="overflow-hidden px-5">
      <FlagshipSliderLayout>
        {items.map((item, index) => {
          return (
            <WrappedCarouselItem
              item={item}
              key={`${item.id}-0`}
              onClick={onClick}
              onClickPrice={onClickPrice}
              analyticsContext={{
                slideIndex: index,
                totalSlides: items.length,
              }}
            />
          );
        })}
        {children}
      </FlagshipSliderLayout>
    </div>
  );
};
